import { useEffect, useRef } from "react";
import { registerForPush } from "./pushNotifications";

/**
 * Trigger the Capacitor push-notifications registration flow once the user
 * is authenticated. Safe no-op on the web.
 *
 * @param {string} persona  "customer" | "rider" | "admin"
 * @param {boolean} ready   gate registration until auth context is loaded
 */
export default function usePushRegistration(persona, ready = true) {
  // Re-register when the PERSONA changes, not just once ever. With a single
  // app hosting customer, admin and rider login, the same mounted tree can
  // legitimately go from one role to another (log out, log back in as
  // someone else). A once-only guard left the device registered against the
  // PREVIOUS user, so notifications kept going to whoever logged in first.
  const ranForRef = useRef(null);
  useEffect(() => {
    if (!ready || !persona) return;
    if (ranForRef.current === persona) return;
    ranForRef.current = persona;
    registerForPush(persona).catch(() => { /* swallow — already logged */ });
  }, [persona, ready]);
}
